import { version } from "../../package.json";

// Capture launch metadata before routing removes the initial query parameters.
const hostVersion = new URLSearchParams(window.location.search).get("hostVersion")?.trim();

export const appVersion = hostVersion ? `${hostVersion}/${version}` : version;
